<template>
<div>
  <add-heading :title="this.$t('profile.tags')" v-on:add="addClicked" :label="this.$t('profile.add')" />
  <skills-list :skills="skills" :editable="true" v-on:add="addClicked" />
</div>
</template>

<script>
import AddHeading from '@/components/general/add-heading'
import SkillsList from '@/components/skills/skills-list'
import { mapState, mapActions } from 'vuex'

export default {
  components: { AddHeading, SkillsList },
  methods: {
    addClicked () {
      this.$emit('add')
    },
    ...mapActions('skills', [
      'getSkills'
    ])
  },
  computed: {
    ...mapState('skills', [
      'skills'
    ]),
    noSkills () {
      return !this.skills || this.skills.length === 0
    }
  },
  mounted () {
    this.getSkills()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/skills/skills-section.vue